// src/components/ConsentBanner.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { setConsentGranted, setConsentRefused, getStoredConsent } from '../analytics/consent';
import { trackConsentChoice, trackNavClick } from '../analytics/events';

const CookieIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M21.598 11.064a1.006 1.006 0 0 0-.854-.172A2.938 2.938 0 0 1 20 11c-1.654 0-3-1.346-3.003-2.937.005-.034.016-.136.017-.17a.998.998 0 0 0-1.254-1.006A2.964 2.964 0 0 1 15 7c-1.654 0-3-1.346-3-3 0-.217.031-.444.099-.717a1 1 0 0 0-1.151-1.236 10.038 10.038 0 0 0-7.886 7.885 9.984 9.984 0 0 0 2.376 8.298 9.96 9.96 0 0 0 7.461 3.367c.395 0 .795-.026 1.198-.077a9.997 9.997 0 0 0 8.512-7.885 1 1 0 0 0-.011-.571zM12 18a4 4 0 1 1 0-8 4 4 0 0 1 0 8z" fill="#0736B2"/>
    <circle cx="9.5" cy="13" r="1.2" fill="#ffb300"/>
    <circle cx="13" cy="15.5" r="1" fill="#ffb300"/>
    <circle cx="14" cy="11.5" r="0.8" fill="#ffb300"/>
  </svg>
);

export default function ConsentBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = getStoredConsent();
    if (!stored) setVisible(true);
  }, []);

  if (!visible) return null;

  const handleAccept = () => {
    setConsentGranted();
    trackConsentChoice({ choice: 'accepted' });
    setVisible(false);
  };
  const handleRefuse = () => {
    setConsentRefused();
    trackConsentChoice({ choice: 'refused' });
    setVisible(false);
  };
  const handleLearnMore = () => {
    trackNavClick({ target: 'consent_learn_more', location: 'consent_banner' });
  };

  return (
    <div className="consent-banner" role="dialog" aria-live="polite" aria-labelledby="consent-banner-title">
      <div className="consent-banner-icon">
        <CookieIcon />
      </div>
      <div className="consent-banner-body">
        <h2 id="consent-banner-title" className="consent-banner-title">
          {t('common:consent_banner.title')}
        </h2>
        <p className="consent-banner-text">
          {t('common:consent_banner.text')}{' '}
          <Link
            to="/politique-de-confidentialite"
            className="consent-banner-link"
            onClick={handleLearnMore}
          >
            {t('common:consent_banner.learn_more')}
          </Link>
        </p>
      </div>
      <div className="consent-banner-actions">
        <button type="button" className="consent-btn consent-btn-refuse" onClick={handleRefuse}>
          {t('common:consent_banner.refuse')}
        </button>
        <button type="button" className="consent-btn consent-btn-accept" onClick={handleAccept}>
          {t('common:consent_banner.accept')}
        </button>
      </div>
    </div>
  );
}
